<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#f2f2f2">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_cliente.new ? "Novo cliente" : get_cliente.nome }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </transition>
        <div class="client-hero">
          <v-avatar size="54" color="#e8f7ef">
            <v-icon color="#1f8f55" size="32">{{ isPJ ? "mdi-domain" : "mdi-account" }}</v-icon>
          </v-avatar>
          <div class="client-hero-copy">
            <strong>{{ get_cliente.nome || get_cliente.razao_social || "Cliente sem nome" }}</strong>
            <small>{{ isPJ ? "Pessoa juridica" : "Pessoa fisica" }} · {{ primaryDocument }}</small>
          </div>
          <v-chip small color="#25D366" dark>
            <v-icon small left>mdi-whatsapp</v-icon>{{ whatsappLinks.length }} vinculo(s)
          </v-chip>
        </div>
      </div>
    </v-flex>
    <div
      style="min-height: 80vh; max-height: 80vh;"
      class="windows-style-content expande-horizontal wrap"
    >
      <v-tabs
        v-model="tabs"
        :background-color="$theme.primary"
        dark
        class="fonte"
      >
        <v-tab>Info do Cliente</v-tab>
        <v-tab @click="listClientSales">Compras do cliente</v-tab>
        <v-tab>Vinculos WhatsApp</v-tab>
      </v-tabs>
      <v-flex v-if="tabs == 0" xs12>
        <v-form ref="form">
          <v-flex class="px-2 pt-3" xs12>
            <v-btn-toggle v-model="get_cliente.client_type" mandatory rounded dense>
              <v-btn value="pf"><v-icon small left>mdi-account</v-icon>PF</v-btn>
              <v-btn value="pj"><v-icon small left>mdi-domain</v-icon>PJ</v-btn>
            </v-btn-toggle>
            <span class="caption ml-2">PJ permite varios numeros de funcionarios vinculados ao mesmo cliente.</span>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-text-field
              v-model="get_cliente.nome"
              filled
              :label="isPJ ? 'Nome fantasia' : 'Nome'"
              clearable
              :color="$theme.primary"
              :rules="[v => !!v || 'Preencha este campo']"
              placeholder="ex: Roberto"
            ></v-text-field>
          </v-flex>
          <v-flex v-if="isPJ" class="px-2" xs12>
            <v-text-field
              v-model="get_cliente.razao_social"
              filled
              label="Razao social"
              clearable
              :color="$theme.primary"
              placeholder="ex: Empresa LTDA"
            ></v-text-field>
          </v-flex>

          <v-flex class="px-2" xs12>
            <v-text-field
              v-model="get_cliente.email"
              clearable
              filled
              :color="$theme.primary"
              label="Email"
              placeholder="ex: meuemail@gmail.com"
            ></v-text-field>
          </v-flex>

          <div class="expande-horizontal wrap">
            <v-flex v-if="!isPJ" class="px-2" xs12 md4>
              <v-text-field
                v-model="get_cliente.cpf"
                label="CPF"
                v-mask="['###.###.###-##']"
                filled
                clearable
                :color="$theme.primary"
                placeholder="ex: 000.000.000-00"
              ></v-text-field>
            </v-flex>
            <v-flex v-else class="px-2" xs12 md4>
              <v-text-field
                v-model="get_cliente.cnpj"
                label="CNPJ"
                filled
                clearable
                :color="$theme.primary"
                placeholder="ex: 00.000.000/0001-00"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md4>
              <v-text-field
                v-model="get_cliente.telefone"
                label="Celular"
                v-mask="['(##) # #### ####']"
                clearable
                filled
                :color="$theme.primary"
                placeholder="ex: (96) 9 8419-6827"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md4>
              <v-text-field
                v-model="get_cliente.data_nascimento"
                label="Nascimento"
                filled
                v-mask="['##/##/####']"
                clearable
                :color="$theme.primary"
                placeholder="ex: 12/12/1984"
              ></v-text-field>
            </v-flex>
          </div>
          <div class="expande-horizontal">
            <v-flex class="px-2" xs12>
              <v-textarea
                v-model="get_cliente.obs"
                label="Anotações sobre o cliente"
                filled
                clearable
                :color="$theme.primary"
              ></v-textarea>
            </v-flex>
          </div>
        </v-form>
      </v-flex>
      <!-- Compras do cliente -->
      <v-flex v-if="tabs == 1" xs12>
        <div class="expande-horizontal wrap">
          <h2 class="fonte-bold ml-3">
            O Cliente realizou {{ sales.length }} compras.
          </h2>
          <div
            style="min-height: 67vh; max-height: 67vh; overflow: auto;"
            class="expande-horizontal px-3"
            v-if="sales.length > 0"
          >
            <v-flex xs12 md3 class="mr-3" v-for="sale in sales" :key="sale._id">
              <SaleItem :kanban="sale" />
            </v-flex>
          </div>

          <div class="expande-horizontal centraliza" v-else>
            <span class="my-12 fonte"
              >Este cliente ainda não realizou nenhuma compra</span
            >
          </div>
        </div>
      </v-flex>
      <v-flex v-if="tabs == 2" xs12>
        <div class="client-links-wrap">
          <div class="client-summary-card">
            <v-icon color="#25D366">mdi-whatsapp</v-icon>
            <div>
              <strong>Vinculos WhatsApp</strong>
              <small>Use estes numeros para reconhecer conversas automaticamente. Empresas PJ podem ter varios funcionarios vinculados.</small>
            </div>
          </div>
          <div class="client-link-form">
            <v-text-field v-model="newWhatsappLink.phone" label="Numero WhatsApp" filled dense :color="$theme.primary" />
            <v-text-field v-model="newWhatsappLink.label" label="Descricao / funcionario" filled dense :color="$theme.primary" />
            <v-btn color="#25D366" dark @click="addWhatsappLink"><v-icon left>mdi-plus</v-icon>Adicionar</v-btn>
          </div>
          <div v-if="whatsappLinks.length" class="client-link-list">
            <div v-for="(link, index) in whatsappLinks" :key="`${link.phone || link.telefone}-${index}`" class="client-link-card">
              <v-avatar color="#e8f7ef" size="38"><v-icon color="#1f8f55">mdi-whatsapp</v-icon></v-avatar>
              <div>
                <strong>{{ link.label || "WhatsApp" }}</strong>
                <small>{{ link.phone || link.telefone }}</small>
              </div>
              <v-spacer />
              <v-btn icon small color="red" @click="removeWhatsappLink(index)"><v-icon small>mdi-delete-outline</v-icon></v-btn>
            </div>
          </div>
          <div v-else class="empty-whatsapp-links">Nenhum vinculo WhatsApp cadastrado ainda.</div>
        </div>
      </v-flex>
    </div>

    <div class="expande-horizontal py-1 windows-style-bottom">
      <v-btn large dark @click="valida_form" :color="$theme.primary">
        <span class="fonte"> Salvar </span>
      </v-btn>
      <!-- <v-btn
        v-if="get_cliente._id"
        color="red"
        class="ml-3"
        @click="excluir_cliente_dialog(get_cliente)"
        text
        >Excluir</v-btn
      > -->
    </div>
  </div>
</template>

<script>
import SaleItem from "@/apps/GestorDePedido/components/SaleItem.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    SaleItem
  },
  computed: {
    ...mapGetters(["get_cliente", "getLoggedUser"]),
    isPJ() {
      return this.get_cliente.client_type === "pj";
    },
    whatsappLinks() {
      return Array.isArray(this.get_cliente.whatsapp_links) ? this.get_cliente.whatsapp_links : [];
    },
    primaryDocument() {
      return this.isPJ ? this.get_cliente.cnpj || "CNPJ nao informado" : this.get_cliente.cpf || "CPF nao informado";
    }
  },
  data() {
    return {
      tabs: 0,
      sales: [],
      newWhatsappLink: { phone: "", label: "" }
    };
  },
  methods: {
    ...mapActions([
      "criar_cliente",
      "atualizar_cliente",
      "fecha_modal_view_cliente",
      "enableLoading",
      "disableLoading"
    ]),
    listClientSales() {
      this.enableLoading();
      this.$run("clientes/list-client-sales", {
        _id: this.get_cliente._id
      }).then(res => {
        this.disableLoading();
        this.sales = res.data;
      });
    },
    valida_form() {
      if (!this.get_cliente.client_type) this.$set(this.get_cliente, "client_type", "pf");
      if (!Array.isArray(this.get_cliente.whatsapp_links)) this.$set(this.get_cliente, "whatsapp_links", []);
      if (this.$refs.form.validate()) {
        this.get_cliente._id ? this.atualizar_cliente() : this.criar_cliente();
      }
    },
    addWhatsappLink() {
      const phone = String(this.newWhatsappLink.phone || "").trim();
      if (!phone) return;
      const links = [...this.whatsappLinks];
      if (!links.some(link => String(link.phone || link.telefone || "").replace(/\D/g, "") === phone.replace(/\D/g, ""))) {
        links.push({ phone, label: this.newWhatsappLink.label || "WhatsApp", linked_at: new Date() });
        this.$set(this.get_cliente, "whatsapp_links", links);
      }
      this.newWhatsappLink = { phone: "", label: "" };
    },
    removeWhatsappLink(index) {
      const links = [...this.whatsappLinks];
      links.splice(index, 1);
      this.$set(this.get_cliente, "whatsapp_links", links);
    },
    backToList() {
      this.$store.commit("set_cliente", {});
      this.$forceUpdate();
    }
  },
  created() {
    if (!this.get_cliente.client_type) this.$set(this.get_cliente, "client_type", "pf");
    if (!Array.isArray(this.get_cliente.whatsapp_links)) this.$set(this.get_cliente, "whatsapp_links", []);
  }
};
</script>

<style scoped>
.client-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 12px;
  padding: 14px;
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(37,211,102,.12), rgba(31,143,85,.06));
  border: 1px solid rgba(31,143,85,.16);
}
.client-hero-copy {
  flex: 1;
  min-width: 0;
}
.client-hero-copy strong,
.client-hero-copy small,
.client-summary-card strong,
.client-summary-card small,
.client-link-card strong,
.client-link-card small {
  display: block;
}
.client-hero-copy strong {
  font-size: 18px;
}
.client-hero-copy small,
.client-summary-card small,
.client-link-card small,
.empty-whatsapp-links {
  color: #6f8178;
}
.client-links-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}
.client-summary-card,
.client-link-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border-radius: 16px;
  background: #f8fbf9;
  border: 1px solid #dfe9e4;
}
.client-link-form {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
  gap: 10px;
  align-items: start;
}
.client-link-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.empty-whatsapp-links {
  padding: 24px;
  text-align: center;
  border: 1px dashed #cbd8d1;
  border-radius: 16px;
}
@media(max-width: 900px) {
  .client-link-form {
    grid-template-columns: 1fr;
  }
}
</style>
